import fetchControlStatus from './fetchControlStatus.api';
import updateControlStatus from './updateControlStatus.api';

const masterControllApi = {
    fetchControlStatus,
    updateControlStatus,
};

export default masterControllApi;
